import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import ReactLink from '@client/components/links/reactLink/ReactLink';
import { BUTTON_SIZES, BUTTON_VARIANTS } from './Button';
import styles from './button.scss';

// A link that looks like a Button, for actions that are really navigation
// (so they can be opened in a new tab). A button cannot sit inside a link.
function ButtonLink({
  to,
  children,
  variant = 'primary',
  size = 'large',
  startIcon,
  endIcon,
  className,
  ...rest
}) {
  return (
    <ReactLink
      to={to}
      className={classNames(
        styles.button,
        styles[variant],
        styles[size],
        className
      )}
      {...rest}
    >
      {startIcon && (
        <span className={styles.icon} aria-hidden="true">
          {startIcon}
        </span>
      )}
      {children}
      {endIcon && (
        <span className={styles.icon} aria-hidden="true">
          {endIcon}
        </span>
      )}
    </ReactLink>
  );
}

ButtonLink.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  children: PropTypes.node,
  variant: PropTypes.oneOf(BUTTON_VARIANTS),
  size: PropTypes.oneOf(BUTTON_SIZES),
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  className: PropTypes.string,
};

export default ButtonLink;
